import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { IMKitHeaderLookupLayout } from '../../../../../common/lookups/Layouts/ImLayouts';
import { KitLayout } from '../Layout';
import KitDetailTab from "./KitDetailTab";
import { WM } from "../../../../../const/constants";
function KitTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [locationLayout, setLocationLayout] = useState(() =>
        IMKitHeaderLookupLayout({ RIdentity: props.formFields?.R_IDENTITY || '' ,ModuleName: WM})
    );
    const [sourceId, setsourceId] = useState(props.formFields?.R_ITEMKITTCODE || '');
    const [formKey, setFormKey] = useState(0);
    const finalLayout = useMemo(() => {
        return KitLayout(locationLayout);
    }, [locationLayout]);
    const handleKitFormLoad = useCallback(() => {
        props.kitFormLookupsLoad();
    }, []);
    useEffect(() => {
        console.log("formFields", props.formFields.R_ITEMKITTCODE);
        setsourceId(props.formFields.R_ITEMKITTCODE);
        const newLayout = IMKitHeaderLookupLayout({ RIdentity: props.formFields?.R_IDENTITY || '' ,ModuleName: WM});
        setLocationLayout(newLayout);
    }, []);
    const handleSelectionChange = useCallback((name, value, e) => {
        console.log(locationLayout);
        if(name == 'R_ITEMKITTCODE'){
            setsourceId(value);
        }
        props.handleKitFieldChange(name, value);
    }, []);
    useEffect(() => {
        setFormKey(prev => prev + 1);
    }, [locationLayout]);
    return (
        <div className="row">
            <div className="col-md-12">
                <FormField
                    currrentUser={currentUser}
                    layoutId='4F432E77-CE59-4037-86FA-6EBBD3D94A42'
                    layoutName='WMItemDataEntryKitForm'
                    defaultFormSchema={finalLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleSelectionChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={props.formRefs}
                    onFormLoad={handleKitFormLoad}
                    handleSelectedItemChange={handleSelectionChange}
                />
            </div>
            <div className="col-md-12">
                    <KitDetailTab sourceId={sourceId}   />
            </div>


        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(KitTab);
